import { fontCaption } from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';
import { Tag, TagBlockProps } from 'libs/growth-platform-brand-system-v2/src/components/Tag';
import { AnimChangeChildren } from 'libs/growth-platform-brand-system-v2/src/utils/AnimChangeChildren';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import React from 'react';
import { getUrlLinkColor, TBannerThemes } from '../bannerThemes';

interface BannerContentProps {
  currentItem: {
    tag?: TagBlockProps[];
    text: string;
    id: string;
  };
  color: TBannerThemes;
  isExpanded: boolean;
  expandedHeight: string;
  collapsedHeight: string;
  contentRef: React.RefObject<HTMLDivElement>;
  animationSettings: {
    exit: { opacity: number; y: number };
    exitTransition: { duration: number };
    initial: { opacity: number; y: number };
    animateTransition: { duration: number; delay: number };
  };
}

export const BannerContent: React.FC<BannerContentProps> = ({
  currentItem,
  isExpanded,
  expandedHeight,
  collapsedHeight,
  contentRef,
  animationSettings,
  color,
}) => (
  <div className="flex justify-center w-full">
    <div className={classNames('flex items-center gap-16 py-16 mx-[40px] md:mx-[48px] container overflow-hidden')}>
      <AnimChangeChildren {...animationSettings}>
        <div key={currentItem.id} className="flex flex-col md:flex-row items-center md:items-start gap-12 w-full text-center md:text-left max-w-[1144px]">
          {currentItem.tag && currentItem.tag.length > 0 && (
            <Tag {...currentItem.tag[0]} size="small">
              {currentItem.tag[0].title}
            </Tag>
          )}
          <div
            style={{
              height: isExpanded ? expandedHeight : collapsedHeight,
              transitionDuration: '300ms'
            }}
            className={classNames("relative w-full overflow-hidden", "transition-all duration-1000 ease-in-out")}
            ref={contentRef}
          >
            {currentItem.text && (
              <div
                className={classNames(
                  fontCaption,
                  "w-full text-center md:text-left [&_a]:underline [&_a]:hover:no-underline [&_a]:transition-all",
                  getUrlLinkColor(color),
                  !isExpanded && "line-clamp-1"
                )}
                dangerouslySetInnerHTML={{ __html: currentItem.text }}
              />
            )}
          </div>
        </div>
      </AnimChangeChildren>
    </div>
  </div>
); 